import Barometer from './Barometer';

export default Barometer;
